import { Controller } from 'stimulus';

export default class extends Controller {
  toggleHotelsFaqItem(event) {
    const button = event.currentTarget;
    const itemId = button.getAttribute('aria-controls');
    const content = this.element.querySelector(`#${itemId}`);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
  }
}
